import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import type { IAlert, IAlertNote, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from './constants';
import formatQueryParams from './formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from './requestTypes';

export const getAlerts = async (
  params?: DataQueryParams,
): Promise<IPage<IAlert>> =>
  await getRequest(API_BASE_PATHS.METADATA.ALERTS, formatQueryParams(params));

export const getAlertCount = async (
  params?: DataQueryParams,
): Promise<{ count: number }> =>
  await getRequest(
    `${API_BASE_PATHS.METADATA.ALERTS}/count`,
    formatQueryParams(params),
  );

export const getAlertNotes = async (
  alertId: string,
  limit?: number,
): Promise<IPage<IAlertNote>> =>
  await getRequest(
    `${API_BASE_PATHS.METADATA.ALERTS}/${alertId}/notes`,
    limit ? { limit } : {},
  );

export const createAlertNote = async (
  alertId: string,
  note: string,
): Promise<string> =>
  await postRequest(
    `${API_BASE_PATHS.METADATA.ALERTS}/${alertId}/note`,
    {},
    { note },
  );

export const updateAlertNote = async (
  alertId: string,
  noteId: number,
  note: string,
): Promise<void> =>
  await patchRequest(
    `${API_BASE_PATHS.METADATA.ALERTS}/${alertId}/notes/${noteId}`,
    {},
    { note },
  );

export const deleteAlertNote = async (
  alertId: string,
  noteId: number,
): Promise<void> =>
  await deleteRequest(
    `${API_BASE_PATHS.METADATA.ALERTS}/${alertId}/notes/${noteId}`,
  );
